(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["mc-girls"] && !Shopify.designMode) return;
  try {
    
/* The arrows page by one tile. Scroll position drives their disabled state,
   so they never promise a move the row cannot make. */
(function () {
  var rows = document.querySelectorAll('[data-girls-row]');

  rows.forEach(function (row) {
    if (row.dataset.girlsBound === 'true') return;
    row.dataset.girlsBound = 'true';

    var section = row.closest('section');
    if (!section) return;

    var prev = section.querySelector('[data-girls-prev]');
    var next = section.querySelector('[data-girls-next]');
    var item = row.firstElementChild;

    function step() {
      if (!item) return row.clientWidth * 0.8;
      var gap = parseFloat(getComputedStyle(row).columnGap) || 0;
      return item.getBoundingClientRect().width + gap;
    }

    function sync() {
      var max = row.scrollWidth - row.clientWidth - 1;
      if (prev) prev.disabled = row.scrollLeft <= 0;
      if (next) next.disabled = row.scrollLeft >= max;
    }

    if (prev) {
      prev.addEventListener('click', function () {
        row.scrollBy({ left: -step(), behavior: 'smooth' });
      });
    }
    if (next) {
      next.addEventListener('click', function () {
        row.scrollBy({ left: step(), behavior: 'smooth' });
      });
    }

    row.addEventListener('scroll', sync, { passive: true });
    window.addEventListener('resize', sync);
    sync();
  });
})();

  } catch(e) { console.error(e); }
})();
})();
